import Model from '/lib/model'

export default \
class ChannelPartner extends Model
  @className: 'ChannelPartner'
  constructor: ->
    super arguments...
    @id             = null
    @name           = null
    @tm_identifier  = null
    @uuid           = null
    @note           = null
    @created_at     = null
    @updated_at     = null
